import styles from "./forcezalooauthblock.module.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, Bounce } from "react-toastify";
import LoginWithZaloButton from "../LoginWithZaloButton";

export default function ForceZaloOAuthBlock({ userId, phoneNumber }) {
  const { t } = useTranslation();

  const [errorOTP, setErrorOTP] = useState("");

  return (
    <div className={styles.signupBlock}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <h2 className={styles.signupText}>{t("signup")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <LoginWithZaloButton userId={userId} phoneNumber={phoneNumber}/>
        </div>
        <span>{t(errorOTP)}</span>
      </div>
      <p className={styles.tosInfo}>
        {t("agreement")} <a href="terms-of-service">{t("terms")}</a> &{" "}
        <a href="privacy-policy">{t("privacy")}</a>
      </p>
    </div>
  );
}
